var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C0B990D3-A685-4DCB-BA41-6F76150AE522@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7992",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1AE65",
    offset: "50.5110841%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C54D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inexplor\\xE9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Abonnement",
    transform: "translate(-403.000000, -783.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(168.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-2",
    transform: "translate(0.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-/-Mobile-/-Primary",
    transform: "translate(213.000000, 343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(22.750000, 16.250000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8661165,0.366116524 C13.3542719,-0.122038841 14.1457281,-0.122038841 14.6338835,0.366116524 L22.1338835,7.86611652 C22.1636167,7.89584972 22.1918589,7.92707386 22.2184885,7.95966717 C22.2338816,7.97838223 22.2488509,7.99781554 22.2631708,8.01757335 C22.2731093,8.03145766 22.2828841,8.04555316 22.2923723,8.05985521 C22.3048698,8.07849133 22.3167223,8.09745069 22.3280183,8.11664701 C22.3380901,8.13394817 22.3480088,8.15176443 22.357498,8.16984155 C22.3691222,8.19185801 22.3798384,8.21388649 22.3898693,8.23614847 C22.3960022,8.24979429 22.4020615,8.26389191 22.4078662,8.27812049 C22.4183106,8.30381015 22.4277904,8.32953285 22.4363968,8.35548173 C22.4409034,8.3688092 22.4452949,8.38282368 22.449444,8.39694192 C22.456711,8.42207764 22.4631233,8.44676594 22.4687699,8.47159319 C22.472689,8.48827104 22.4763232,8.50595367 22.4795798,8.52376821 C22.4837846,8.54739246 22.4873164,8.57035335 22.4902079,8.59337931 C22.4966718,8.64430108 22.5,8.69676187 22.5,8.75 L22.4963388,8.65410496 C22.4978443,8.67378973 22.4988855,8.69350335 22.4994624,8.71322803 L22.5,8.75 C22.5,8.76223072 22.4998243,8.7744204 22.4994754,8.78656668 C22.4988855,8.80649665 22.4978443,8.82621027 22.4963388,8.84589504 C22.4948136,8.8664886 22.4927556,8.88691263 22.4902121,8.90718565 C22.4873164,8.92964665 22.4837846,8.95260754 22.4796124,8.97547454 C22.4763232,8.99404633 22.472689,9.01172896 22.4686857,9.0292711 C22.4631233,9.05323406 22.456711,9.07792236 22.449533,9.10243403 C22.4452949,9.11717632 22.4409034,9.1311908 22.4362742,9.14509668 C22.4277904,9.17046715 22.4183106,9.19618985 22.4079574,9.22164045 C22.4020615,9.23610809 22.3960022,9.25020571 22.3896939,9.26416671 C22.3798384,9.28611351 22.3691222,9.30814199 22.3577208,9.32990506 C22.3480088,9.34823557 22.3380901,9.36605183 22.3277553,9.38359366 C22.3167223,9.40254931 22.3048698,9.42150867 22.2924609,9.44020772 C22.2828841,9.45444684 22.2731093,9.46854234 22.2630563,9.4824231 C22.2247498,9.53543782 22.181654,9.58611292 22.1338835,9.63388348 L22.2184885,9.54033283 L22.1338835,9.63388348 L14.6338835,17.1338835 C14.1457281,17.6220388 13.3542719,17.6220388 12.8661165,17.1338835 C12.3779612,16.6457281 12.3779612,15.8542719 12.8661165,15.3661165 L18.232,10 L1.25,10 C0.602791309,10 0.0704661011,9.50812534 0.00645360909,8.87780524 L-5.32907052e-15,8.75 C-5.32907052e-15,8.05964406 0.559644063,7.5 1.25,7.5 L18.232,7.5 L12.8661165,2.13388348 C12.4105048,1.6782718 12.3801307,0.958451381 12.7749942,0.467611874 Z",
    id: "Combined-Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArrow);
export default __webpack_public_path__ + "static/media/ButtonArrow.3b3aab8a4c791f05ab686276311247bf.svg";
export { ForwardRef as ReactComponent };